import React from "react";

const Beyond = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M12.497 28.917h10.117A9.445 9.445 0 0 1 17.556 34a9.445 9.445 0 0 1-5.059-5.083Zm13.725-7.54 2.89 3.292v2.797H6v-2.797l2.889-3.292V12.95c0-5.055 3.617-9.357 8.667-10.951 5.05 1.594 8.666 5.896 8.666 10.951v8.426Zm-8.666-5.523c.766 0 1.5-.306 2.042-.85a2.91 2.91 0 0 0 0-4.105 2.882 2.882 0 0 0-4.085 0 2.91 2.91 0 0 0 0 4.105c.542.544 1.276.85 2.043.85Z"
            fill={fill}
        />
    </svg>
);

export default Beyond;
